import React, {useState, useRef, useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import { useReactToPrint } from 'react-to-print'
import apiLink from '../../config.js'

import PRINT from '../../assets/Icones/imprimante.png'
import Entete from '../MEP/entete'
import PageDeGarde from './1_page_de_garde';
import PageProduction from './2_production.js';
import PageRiskRDT from './3_risk_rdt';
import PageRiskRDTCarte from './4_risk_rdt_carte';
import Page20302050 from './5_2030_2050.js'
import Page203020504D from './5-2_2030_2050 4D.js'
import PageAleasPDF from './6_1_aleas_climatiques.js'
import PageAleasPDF2 from './6_2_aleas_climatiques2.js'
import PageAleasPDF3 from './7_1_aleas_climatiques3.js'
import PageAleasPDF4 from './7_2_aleas_climatiques4.js'
import PageSolCepage from './8_Solutions-cepage.js'
import PageAFOM from './9_AFOM.js'
import PageOpti from './10_opti';
import PageHow from './11_how';
import Couv4eme from './12_4eme_couv';
import PageRiskPrix from './risk_prix';
import PageResistance1 from './resistance1';
import PageRistance2 from './resistance2';

function RapportPDF() {
    const { state } = useLocation();
    const { idExploit } = state;

    const [vitiPres, setVitiPres] = useState(false)
    const [queViti, setQueViti] = useState(false)

    const componentRef = useRef();
    const today = new Date().toISOString().split('T')[0]; // Format YYYY-MM-DD
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'rapport_DiagoRisk_' + idExploit + '_' + today
    })
    function fetchData() {
        //fetch(apiLink + 'page/production-rapport/' + idExploit)
        const token = localStorage.getItem('token');
        fetch(apiLink + 'page/production-rapport', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
                idExploitation: idExploit
            })
         })
        .then( (response) => {
        return response.json()
        })
        .then(response =>{
        let data = response
        for (var cle in data) {
            if (cle.includes("Vignes")) {
                setVitiPres(true)
            }
        }
        let allKeysContainVignes = Object.keys(data).every(cle => cle.includes("Vignes"));
        if (allKeysContainVignes) {
            setQueViti(true);
        } else {
            setQueViti(false);
        }
        })
    }

    useEffect ( () => {
        fetchData()
      }, [idExploit])
    
    return (
        <>
        <button className='buttonPrint' onClick={handlePrint} > <img src={PRINT} className="IconHome" alt="Bouton d'impression"/></button>
        <div ref={componentRef}>
            <Entete titre="Prévisualisation du rapport" rapport={true}/>

            <div className="container containerButtonPrint" style={{marginBottom:'0px'}}> 
                <PageDeGarde idExploit={idExploit}/>
                <PageProduction idExploit={idExploit}/>
                <PageRiskRDT idExploit={idExploit}/>
                {/* <PageRiskRDTCarte idExploit={idExploit}/> */}
                <Page20302050 idExploit={idExploit}/>
                <Page203020504D idExploit={idExploit}/>
                <div className={queViti? 'HideResult' : 'ShowResult'}><PageAleasPDF idExploit={idExploit}/></div>
                <div className={queViti? 'HideResult' : 'ShowResult'}><PageAleasPDF2 idExploit={idExploit}/></div>
                <PageAleasPDF3 idExploit={idExploit}/>
                <PageAleasPDF4 idExploit={idExploit}/>
                {/* <PageRiskPrix idExploit={idExploit}/> 
                <PageResistance1 idExploit={idExploit}/>
                <PageRistance2 idExploit={idExploit}/>*/}
                <div className={vitiPres=== false ? 'HideResult' : 'ShowResult'}><PageSolCepage idExploit={idExploit}/></div>
                <PageAFOM idExploit={idExploit}/>
                {/* <PageOpti idExploit={idExploit}/>
                <PageHow idExploit={idExploit}/> */}
                <Couv4eme/>
            </div>
        </div> 
        <button className='validation' onClick={handlePrint} style={{marginTop:'10px',marginLeft:'1%', width:'98%', marginBottom:"10px"}}> Imprimer ce rapport </button>
        </>
    )
}

export default RapportPDF